import { createContext, useContext, useState, useEffect } from 'react';
import {isNil, isEmpty, reject, includes} from 'ramda'

const baDataContext = createContext();

const dataIsValid = (data) => {
  return !isNil(data) && !isEmpty(data)
}

// const removeMatchingPlayers = (masterList, subset) => {
//   const subsetIDs = map(prop('ID'), subset); // Extract IDs from subset
//   return reject(player => includes(player.ID, subsetIDs), masterList);
// };

export const BADataProvider = ({ children }) => {
    const [baData, setBAData] = useState(null)
    const [uploadedData, setUploadedData] = useState(null)
    const [activeBAData, setActiveBAData] = useState(null)
    const [baDataLoading, setBADataLoading] = useState(false)
    const [baDataError, setBADataError] = useState(false)
    const [activeBADataSetName, setActiveBADataSetName] = useState("")
    const [activeBADataSet, setActiveBADataSet] = useState(null)

    useEffect(() => {
      if (dataIsValid(baData)) {
        //TODO: look at this
        setActiveBAData(baData[0])
      }
    }, [baData, setActiveBAData])

    useEffect(() => {
      if (!isNil(uploadedData)) {
        const newActiveData = baData.find(item => item.setName === activeBADataSetName)
        console.log({newActiveData})
          if (uploadedData.length > 0) {
            const filteredBaData = {data: reject(player => includes(player.playerId, uploadedData), newActiveData.data), setName: newActiveData.setName}
            console.log("active data set: " + filteredBaData.setName)
            console.log({filteredBaData})
            setActiveBAData(filteredBaData)
          } else {
            console.log("no uploaded data")
            setActiveBAData(newActiveData)
          }
      }
    }, [uploadedData, baData, setActiveBAData, activeBADataSetName])

    useEffect(() => {
      if(dataIsValid(activeBAData)) {
        setActiveBADataSetName(activeBAData.setName)
        setActiveBADataSet(activeBAData.data)
      }
    }, [activeBAData, setActiveBADataSetName, setActiveBADataSet])

  
    return (
      <baDataContext.Provider value={{ baData, setBAData, uploadedData, setUploadedData, activeBAData, setActiveBAData, baDataLoading, setBADataLoading, baDataError, setBADataError, activeBADataSetName, setActiveBADataSetName, activeBADataSet, setActiveBADataSet }}>
        {children}
      </baDataContext.Provider>
    )
  }
  
export const useBAData = () => {
const { baData, setBAData, setUploadedData, activeBAData, setActiveBAData, baDataLoading, setBADataLoading, baDataError, setBADataError, activeBADataSetName, setActiveBADataSetName, activeBADataSet, setActiveBADataSet } = useContext(baDataContext)
return { baData, setBAData, setUploadedData, activeBAData, setActiveBAData, baDataLoading, setBADataLoading, baDataError, setBADataError, activeBADataSetName, setActiveBADataSetName, activeBADataSet, setActiveBADataSet }
}